namespace $ {

	/** Cancellation adapter for the protected task API of duckdb-wasm 1.33.1-dev45.0. */
	export class $shm_duckdb_worker extends $mol_object2 {

		static spawn( Base: any, logger: any, worker: Worker, failed: (error: Error)=>void ): any {
			return new class extends Base {
				closed_reason: Error | null = null
				failure: ((error: Error)=>void) | null = failed
				message_error = (event: MessageEvent)=> this.fail( new Error( 'DuckDB worker message could not be decoded' ) )

				constructor() {
					super( logger, worker )
					worker.addEventListener( 'messageerror', this.message_error )
				}

				abort( error: Error ) {
					if( this.closed_reason ) return
					this.closed_reason = error
					// Native onError/terminate clear or abandon this map without rejecting callers.
					for( const task of this._pendingRequests.values() ) task.promiseRejecter( error )
					this._pendingRequests.clear()
				}

				async postTask( task: any, transfer: ArrayBuffer[] = [] ) {
					if( this.closed_reason ) throw this.closed_reason
					return super.postTask( task, transfer )
				}

				fail( error: Error ) {
					if( this.closed_reason ) return
					this.abort( error )
					this.failure?.( error )
					void this.terminate().catch( (error: unknown)=> console.error( 'DuckDB worker termination failed', error ) )
				}

				onError( event: ErrorEvent ) {
					this.fail( new Error( event.message || 'DuckDB worker failed' ) )
				}

				onClose() {
					this.fail( new Error( 'DuckDB worker closed unexpectedly' ) )
				}

				async terminate() {
					this.abort( new Error( 'DuckDB worker was terminated' ) )
					this.failure = null
					const active = this._worker as Worker | null
					if( active ) {
						active.removeEventListener( 'messageerror', this.message_error )
						active.removeEventListener( 'message', this._onMessageHandler )
						active.removeEventListener( 'error', this._onErrorHandler )
						active.removeEventListener( 'close', this._onCloseHandler )
						this._workerShutdownResolver( null )
					}
					await super.terminate()
				}
			}()
		}
	}
}
